import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MarketingPage from './marketing-page/MarketingPage';

const PrivacyPolicy = lazy(() => import('./PrivacyPolicy'));
const PrivacyPolicySMS = lazy(() => import('./PrivacyPolicySMS'));
const TermsOfService = lazy(() => import('./TermsOfService'));
const TermsOfServiceSMS = lazy(() => import('./TermsOfServiceSMS'));

function App() {
  return (
    <Router>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<MarketingPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/privacy-sms" element={<PrivacyPolicySMS />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/terms-sms" element={<TermsOfServiceSMS />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
